import { Checkbox, Menu, Row } from "antd";
import type { CheckboxValueType } from "antd/es/checkbox/Group";
import React, { useState } from "react";
import {
    useGetEnquiryCategoryQuery,
    useGetIndustryQuery,
    useGetTypesQuery
} from "../../services/api";
import { CommonButton } from "../CommonButton/button";
import "./index.css";
const { SubMenu } = Menu;

const region = [{ region_name: "kerala" }, { region_name: "karnataka" }];

const type = [{ type_name: "type 1" }, { type_name: "type 2" }];

const industry = [
  { industry_name: "industry 1" },
  { industry_name: "industry 2" },
];
interface IFilter {
  setFilter: (data: boolean) => void;
  setFilterData: (data: any) => void;
  filer: boolean;
  setSelectedRegion: (data: any) => void;
  selectedRegion: any;
  selectedStatus: string[];
  setSelectedStatus: (data: string[]) => void;
}
export const QuotationFilter: React.FC<IFilter> = ({
  setFilter,
  setFilterData,
  filer,
  setSelectedRegion,
  selectedRegion,
  selectedStatus,
  setSelectedStatus,
}) => {
  // const [selectedRegion, setSelectedRegion] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const [localSelectedStatus, setLocalSelectedStatus] =
    useState<string[]>(selectedStatus);

  const { data: industryData, isLoading: industyLoading } =
    useGetIndustryQuery("");
  const { data: enqiryData, isLoading: regionLoading } =
    useGetEnquiryCategoryQuery("");
  const handleRegionChange = (selectedItems: any) => {
    setSelectedRegion(selectedItems);
  };
  const { data: typeData, isLoading: typeLoading } = useGetTypesQuery("");

  const handleTypeChange = (selectedItems: any) => {
    setSelectedType(selectedItems);
  };

  const handleIndustryChange = (selectedItems: any) => {
    setSelectedIndustry(selectedItems);
  };

  // Handle Status filter change
  const handleStatusChange = (checkedValues: CheckboxValueType[]) => {
    const nextSelectedStatus = checkedValues as string[];
    setLocalSelectedStatus(nextSelectedStatus);
    setSelectedStatus(nextSelectedStatus);
  };

  const handleFilter = () => {
    // Perform filtering based on selected filters
    // You can implement the filtering logic here
    const filterDatas: any = {};

    if (selectedRegion?.length > 0) {
      filterDatas.sales_lead__enquiry_category__in = selectedRegion;
    }

    if (selectedType?.length > 0) {
      filterDatas.type__in = selectedType;
    }

    if (selectedIndustry?.length > 0) {
      filterDatas.industry__in = selectedIndustry;
    }

    // Status filter
    if (localSelectedStatus?.length === 1) {
      if (localSelectedStatus[0] === "active") {
        filterDatas.is_closed = 0;
      } else if (localSelectedStatus[0] === "closed") {
        filterDatas.is_closed = 1;
      }
    }

    setFilterData(filterDatas);
    setFilter(false);
  };

  const handleCancel = () => {
    // Reset the selected filters
    // setFilter(false);
    setSelectedRegion([]);
    setSelectedType([]);
    setSelectedIndustry([]);
    setLocalSelectedStatus([]);
    if (setSelectedStatus) {
      setSelectedStatus([]);
    }
    setFilterData({});
    setFilter(false);
  };

  const handleOpenChange = (keys: any) => {
    setOpenKeys(keys);
  };

  // Status options
  const statusOptions = [
    { value: "active", label: "Active", is_closed: 0 },
    { value: "closed", label: "Closed", is_closed: 1 },
  ];

  return (
    <Menu
      mode="inline"
      style={{ width: 215 }}
      defaultOpenKeys={openKeys}
      openKeys={openKeys}
      onOpenChange={handleOpenChange}
      className="filter-drop-down"
    >
      {/* Render region filter */}
      <SubMenu key="region" title="Enquiry Category" className="w-full">
        <Checkbox.Group value={selectedRegion} onChange={handleRegionChange}>
          {enqiryData?.map((item: any) => (
            <Menu.Item key={item.id}>
              <Checkbox value={item.id}>{item.name}</Checkbox>
            </Menu.Item>
          ))}
        </Checkbox.Group>
      </SubMenu>

      {/* Status Filter */}
      <SubMenu key="status" title="Status" className="w-full">
        <Checkbox.Group
          value={localSelectedStatus}
          onChange={handleStatusChange}
        >
          {statusOptions.map((item) => (
            <Menu.Item key={item.value}>
              <Checkbox value={item.value}>{item.label}</Checkbox>
            </Menu.Item>
          ))}
        </Checkbox.Group>
      </SubMenu>

      {/* Render type filter */}
      {/* <SubMenu key="type" title="Type" className="w-full">
        <Checkbox.Group value={selectedType} onChange={handleTypeChange}>
          {typeData?.map((item: any) => (
            <Menu.Item key={item.id}>
              <Checkbox value={item.id}>{item.name}</Checkbox>
            </Menu.Item>
          ))}
        </Checkbox.Group>
      </SubMenu> */}

      {/* Render industry filter */}
      {/* <SubMenu key="industry" title="Industry" className="w-full">
        <Checkbox.Group
          value={selectedIndustry}
          onChange={handleIndustryChange}
        >
          {industryData?.map((item: any) => (
            <Menu.Item key={item.id}>
              <Checkbox value={item.id}>{item.name}</Checkbox>
            </Menu.Item>
          ))}
        </Checkbox.Group>
      </SubMenu> */}

      {/* Render filter and cancel buttons */}
      <Menu.Item
        key="filter"
        style={{
          textAlign: "start",
        }}
        className="filter-drop-down"
      >
        <Row justify={"space-between"}>
          {/* <Button onClick={handleCancel}>Reset</Button> */}
          <CommonButton
            variant="wearlay-without-bg"
            onClick={handleCancel}
            value="Reset"
            className="reset"
          />
          {/* <Button type="primary" onClick={handleFilter}>
            Ok
          </Button> */}
          <CommonButton
            variant="wealay-primary-btn"
            onClick={handleFilter}
            value="Ok"
          />
        </Row>
      </Menu.Item>
    </Menu>
  );
};

export default QuotationFilter;
